import React from 'react';

const AboutMe = () => {
    return (
        <div className='container w-80 my-5 py-3'>
            <h2> I am Ranjit K. Mandal</h2>
            <p>I'm Ranjit Kumar Mandal. I'm a small business owner. I want to increase my income with freelancing or some own small webdevelopment company for local country or international company, I'm trying to develop my skill. End of this year 2022 around septembor I could add some extra income from my webdevelopment knowledge</p>
        </div>
    );
};

export default AboutMe;